import axios from "axios";
import { BACKEND_BASE_URL } from "../constants/contants";

const axiosInstance = axios.create({
  baseURL: BACKEND_BASE_URL,
  withCredentials: true,
});

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    // 👇 No response: network error, backend down
    if (!error.response) {
      console.error("Backend unreachable", error.message);
      window.location.href = "/#/login";
      return Promise.reject(error);
    }
    const { status } = error.response;
    // 👇 Unauthorized (maybe session expired)
    if (status === 401) {
      localStorage.removeItem("userInfo"); // clear any local data
      window.location.href = "/#/login";
      return Promise.reject(error);
    }
  }
);

export default axiosInstance;
